<div class="page">
  <router-outlet></router-outlet>
</div>
